export const isMathPracticeSignedTip = (tipType: string): boolean =>
  ['ST4', 'ST5', 'ST6', 'ST7', 'ST8', 'ST9', 'ST10', 'ST11'].includes(tipType);
